// extracted by mini-css-extract-plugin
export default {"mainLoadercontainer":"loader_mainLoadercontainer__vEgxb","mainLoader":"loader_mainLoader__LjiVG","spin":"loader_spin__az7D0"};